import styled from 'styled-components';

import { PriceCompareMessage } from '../../../../../types/PriceCompareMessage';
import { ReachInformationCategory } from '../../../../../types/ReachInformationMessage';
import { ScheduleMessage } from '../../../../../types/ScheduleMessage';
import { theme } from '../../../../common/ui/theme';
import { PriceCompareCategory } from '../../PriceCompare/PriceCompareCategory';
import { ScheduleLayout } from '../scheduleLayout';

interface ScheduleItemBase {
    stop: ScheduleMessage;
    vesselId: string;
    reachInformation?: { [category: string]: ReachInformationCategory };
}

interface ScheduleProductItem extends ScheduleItemBase {
    prices: { [category: string]: PriceCompareMessage[] } | null;
}

export type ScheduleItem = ScheduleProductItem;

const ProductFrame = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: ${ScheduleLayout.CARD_WIDTH};
    height: ${ScheduleLayout.ROW_HEIGHT};
    gap: ${theme.space[16]};

    box-shadow: none;
    border: 1px solid ${theme.colors.border.muted};
    transition: box-shadow 100ms ease-in-out;
    border-radius: ${theme.radii[6]};
    background-color: ${theme.colors.background.default};

    &:hover {
        box-shadow: ${theme.shadows.medium};
    }
`;

interface ScheduleProductCardProps {
    categoryData: PriceCompareMessage[] | null;
    reachInformation?: ReachInformationCategory;
    isColumnHovered: boolean;
}

export const ScheduleProductCard = ({ categoryData, reachInformation, isColumnHovered }: ScheduleProductCardProps) => {
    return (
        <ProductFrame>
            <PriceCompareCategory
                priceData={categoryData ?? []}
                reachInformation={reachInformation}
                isColumnHovered={isColumnHovered}
            />
        </ProductFrame>
    );
};
